import { useActiveTabFromMatch } from "@shared";

import { AppRoutes } from "@/router/AppRoutes";
import { DutyScheduleTab } from "@/router/DutyScheduleRoutes";

/**
 * The tab the current URL is on. Falls back to the first tab so the bar always has a selection,
 * including on the bare detail route before the index redirect settles.
 */
export function useActiveDutyScheduleTab(): DutyScheduleTab {
  return useActiveTabFromMatch(`${AppRoutes.DutySchedule}/:id/:tab`, DutyScheduleTab) ?? DutyScheduleTab.DataEntry;
}
